import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { RequestMaker } from '../../request-maker';
var RecommendationsRequestMaker = /*#__PURE__*/function (_RequestMaker) {
  _inherits(RecommendationsRequestMaker, _RequestMaker);
  var _super = _createSuper(RecommendationsRequestMaker);
  function RecommendationsRequestMaker() {
    _classCallCheck(this, RecommendationsRequestMaker);
    return _super.apply(this, arguments);
  }
  _createClass(RecommendationsRequestMaker, [{
    key: "makeRequest",
    value: function makeRequest(makeRequestParams) {
      var contextResolver = makeRequestParams.contextResolver,
        first = makeRequestParams.first,
        rerank = makeRequestParams.rerank;
      return new Request(this.endpoint, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: this.getHeaders(),
        body: JSON.stringify({
          query: recommendationsQuery,
          variables: {
            first: first,
            context: this.getContext(contextResolver),
            rerank: rerank
          }
        })
      });
    }
  }]);
  return RecommendationsRequestMaker;
}(RequestMaker);
export { RecommendationsRequestMaker as default };
var recommendationsQuery = "\nquery GrowthRecQuery($context: GrowthRecContext!, $first: Int!, $rerank: [GrowthRecRerankCandidate!]) {\n  growthRecommendations {\n    recommendations(context: $context, first: $first, rerank: $rerank) {\n      ... on GrowthRecRecommendations {\n        __typename\n        data {\n          __typename\n          entityId\n          reasons\n        }\n      }\n      ... on QueryError {\n        __typename\n        identifier\n        message\n        extensions {\n          __typename\n          statusCode\n          errorType\n        }\n      }\n    }\n  }\n}\n";